import api from "./index";

export async function postDialog(protocol, body) {
  return api.post(`/dialogflow/${protocol}`, body);
}
